import "./App.css";
import Chart from "./components/chart/Chart";

function App() {
  return (
    <>
      <Chart />
    </>
  );
}

export default App;
